import React, { createContext, useContext } from 'react';
import { t } from 'i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import '../CustomMenu/i18n';

import { getCrumbs } from './crumbs';
import styles from './styles';

// Holds `{ current: path => void }`. A form with an unsaved-changes confirm sets `current`
// while mounted so breadcrumb links ask before leaving, the same as its Volver button.
export const LeaveGuardContext = createContext({ current: null });

// Acciones (published or draft) are known by their code.
const CODED_RESOURCES = ['actions', 'draft-actions'];

function Breadcrumbs({ location, resources }) {
  const guard = useContext(LeaveGuardContext);
  const recordLabel = (resource, id) => {
    const record = resources[resource]?.data?.[id];
    if (!record) {
      return undefined;
    }
    if (CODED_RESOURCES.includes(resource)) {
      return record.code || record.name;
    }
    return record.name || record.nameEs || record.title || record.titleEs || record.username;
  };
  const crumbs = getCrumbs(location.pathname, { t, recordLabel });
  if (!crumbs.length) {
    return null;
  }

  const onClick = to => event => {
    if (guard.current) {
      event.preventDefault();
      guard.current(to);
    }
  };

  return (
    <nav aria-label="breadcrumb" style={styles.nav}>
      {crumbs.map((crumb, index) => (
        <span key={index}>
          {index > 0 && <span style={styles.separator}>›</span>}
          {crumb.to ? (
            <Link to={crumb.to} onClick={onClick(crumb.to)} style={styles.link}>
              {crumb.label}
            </Link>
          ) : (
            <span style={styles.current}>{crumb.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export default withRouter(connect(state => ({ resources: state.admin.resources }))(Breadcrumbs));
